import { createStore } from 'vuex'
import {processesState} from "../../processes/store/index";
import {subscriptionsState} from "../../subscriptions/store";

export default createStore({
  modules: {
    processes: processesState,
    subscriptions: subscriptionsState
  },
  state: {
    'modalData': {},
    'confirmData': {}
  },
  mutations: {
    openModal(state, {msg, theme, action, async, inverted}){
      state.modalData.msg = msg;
      state.modalData.theme = theme;
      state.modalData.action = action;
      state.modalData.async = async;
      state.modalData.inverted = inverted;
      state.modalData.showModal = true;
    },
    openConfirmModal(state, {msg, theme}){
      state.confirmData.msg = msg;
      state.confirmData.theme = theme;
      state.confirmData.showModal = true;
    }
  }
})
